import { formatAddedScopeForExport, formatScopeWithAdditionalScopeForExport } from "./scopeDisplayUtils";
import { addedScopeLabels, getCalendarDisplayStatus, getSponsorPrimaryBadge } from "./assessmentCalendarRules";

export const CALENDAR_EXPORT_HEADERS = [
  "Vendor",
  "Sponsor",
  "Scheduled Date",
  "Status",
  "Request Type",
  "Relationship",
  "Scope",
  "Added Scope",
];

export function buildCalendarExportRecords(rows, { isAdmin, today } = {}) {
  return (rows || []).map((row) => ({
    Vendor: row.provider_name || "",
    Sponsor: row.is_browse_only ? "" : row.sponsor_name || "",
    "Scheduled Date": String(row.assessment_start_date || "").slice(0, 10),
    Status: isAdmin
      ? getCalendarDisplayStatus(row, today) || ""
      : getSponsorPrimaryBadge(row) || getCalendarDisplayStatus(row, today) || "",
    "Request Type": row.request_type || "",
    Relationship: relationshipLabel(row),
    Scope: formatScopeWithAdditionalScopeForExport(row.capabilities, row.additional_scope),
    "Added Scope": formatAddedScopeForExport(row.added_scope, addedTagText(row)),
  }));
}

function relationshipLabel(row) {
  if (row?.is_browse_only) return "Browse";
  if (row?.is_pending_join) return "Pending join";
  if (row?.is_accepted_participant) return "Accepted";
  if (row?.is_originator) return "Originator";
  return "";
}

function addedTagText(row) {
  const labels = addedScopeLabels(row).filter(
    (label) => !(row?.added_scope || []).some((item) => item?.rfi_name === label)
  );
  return labels.join(", ");
}
